<template>
    <section class="section section--call-to-action">
        <h2>Dokážeme vaši firmu ozdravit zevnitř.<br />K tomu je však důležité vaše uvědomění toho,<br />že <strong>POTŘEBUJETE ZMĚNU</strong>.</h2>
        <ul>
            <li>Rychle rostete a nemáte vytvořené procesy a efektivní systém?</li>
            <li>Máte na pracovišti nefunkční vztahy?</li>
            <li>Firma stagnuje a nevíte proč?</li>
            <li>Nedaří se vám dlouhodobě udržet kompetentní pracovníky?</li>
            <li>Potřebujete ozdravit či vytvořit firemní kulturu?</li>
        </ul>
        <p class="section__text">Pomůžeme Vám s těmito i dalšími podobnými tématy. Stačí se jen ozvat <br />a domluvit si nezávazné setkání v našich nových kancelářích.</p>
        <button type="button" class="btn" @click="scrollToElement">Chci se rozvíjet</button>
    </section>
</template>

<script>
    export default {
        name: 'CallToAction',
        methods: {
            scrollToElement() {
                const el = document.querySelector('#contact');
                if (el) {
                    el.scrollIntoView({ behavior: 'smooth' });
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    
    .section {

        h2 {
            text-align: center;
            line-height: 1.4;
            font-weight: 300;
            font-size: 2.7rem;
            color: #fff;

            strong {
                font-weight: 500;
                color: #fad2ca;
            }
        }

        ul {
            width: 60rem;
            margin: 5rem auto 0 auto;

            li {
                line-height: 1.6;
                font-size: 1.8rem;
                font-weight: 300;
                color: #fff;

                &:not(:last-of-type) {
                    margin-bottom: .5rem;
                }
            }
        }

        &__text {
            max-width: 90rem;
            margin: 6rem auto 0 auto;
            line-height: 1.5;
            text-align: center;
            font-size: 2rem;
            font-weight: 300;
            color: #f0f0f0;
        }

        .btn {
            margin-top: 6rem;
        }

        &--call-to-action {
            background-color: #333;
        }
    }

    @media (max-width: 767px) {

        .section {

            ul {
                width: auto;
            }
        }
    }

</style>
